import {Component, OnInit} from '@angular/core';
import {CoreConfigService} from '../../../@core/services/config.service';

@Component({
    selector: 'app-courses',
    templateUrl: './courses.component.html',
    styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {

    constructor(public _coreConfigService: CoreConfigService) {
        this._coreConfigService.config = {
            layout: {
                menu: {
                    hidden: true
                },
                animation: 'none',
                customizer: false,
                enableLocalStorage: false,
                type: 'horizontal'
            }
        };
    }

    ngOnInit(): void {
    }

}
